import React from "react";
import { Theme, ThemeContextType } from "../libs/Interfaces";

const ThemeContext = React.createContext<ThemeContextType>({
    setTheme: (theme: Theme | string) => console.log(theme),
    getTheme: "GENERAL"
});

export function useTheme() {
    return React.useContext(ThemeContext);
}

export function ThemeProvider({ children }: { children: any }) {

    const [theme, setTheme] = React.useState<Theme | string>({
        type: "GENERAL"
    });

    function onthemechange(selectedTheme: Theme | string) {
        if (selectedTheme === theme) return;
        let meta = document.getElementsByName("theme-color")[0];
        let color = "#9078A3";
        if (typeof selectedTheme === "string") {
            color = selectedTheme;
        }
        else if (selectedTheme.type === "DARKHOME") {
            color = "#000000";
        }else if (selectedTheme.type === "ERROR") {
            color = "#FF6437";
        }else if (selectedTheme.type === "LIGHT") {
            color = "#FFFFFF";
        }
        if (meta) {
            meta.setAttribute("content",color);
        }
        setTheme(selectedTheme);
    };

    const value: ThemeContextType = {
        setTheme: onthemechange,
        getTheme: theme
    };

    return (
        <ThemeContext.Provider value={value}>
            {children}
        </ThemeContext.Provider>
    );
}